export default class Base {
    assign(property, props, type, defaultValue = "") {
        let rval = props[property] !== undefined ? props[property] : this[property];
        return rval || (type === 'boolean' ? false : 
            type === 'float' ? "0" : defaultValue);
    }
}